import React, { useState, useEffect } from 'react'; 

import { handleResponse } from '../../../../_helpers/handle-response';
import { DropdownDataService } from '../../../../_services/dropdownData.service';
import CONSTANTS from '../../../../_constants/constants';
import { parseFloat2Decimal, parseFloat2DecimalHeader } from '../../../../_helpers/utils';
import classes from './CustomerWiseAPISalesPage.module.css';

import Alert from '../../../UI/Alert/Alert';
import Button from '../../../UI/Button/Button';
import Loader from '../../../UI/Loader/Loader';
import ExportToCSV from '../../../UI/ExportToCSV/ExportToCSV';
import Table from '../../../UI/Table/Table';
import PageLayout from '../../../Layout/PageLayout/PageLayout';

const CustomerWiseAPISalesPage = () => {

    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [fromDate, setFromDate] = useState(new Date().toISOString().slice(0,10));
    const [toDate, setToDate] = useState(new Date().toISOString().slice(0,10));
    const [customerId, setCustomerId] = useState('');
    const [customerData, setCustomerData] = useState([]);
    const [totalData, setTotalData] = useState([]);
    const [gridData, setGridData] = useState([]);
    const [pageCount, setPageCount] = useState(1);
    const [exportFileName, setExportFileName] = useState('');
    const [enableExport, setEnableExport] = useState(false);
    const [exportTotalData, setExportTotalData] = useState({});
    
    const tableHeaders = ['Customer', 'Sales', 'Commission', 'Total Received'];
    const dataFields = ['customerName', 'sales', 'commission', 'total'];
    const csvHeaders = [
        { label: 'Customer', key: 'customerName' },
        { label: 'Sales', key: 'sales' },
        { label: 'Commission', key: 'commission' },
        { label: 'Total Received', key: 'total' }
    ];
    const tableConfig = {
        headerAlignConfig: {
            'Customer': 'left', 
            'Sales': 'center',
            'Commission': 'center',
            'Total Received': 'center',
        },
        widthConfig: {
            'Customer': 'auto', 
            'Sales': '122px',
            'Commission': '122px',
            'Total Received': '122px',
        },
        alignConfig: {
            'customerName': 'left',
            'sales': 'right',
            'commission': 'right',
            'total': 'right'
        }
    };

    useEffect(() => {
        getCustomerList();
    }, []);

    useEffect(() => {
        setEnableExport(false);
        setErrorMessage(null);
    }, [fromDate, toDate, customerId]);

    const getCustomerList = () => {
        DropdownDataService.getCustomerList('filter').then( result => {
            if(result.data) {
                setCustomerId(result.data.results[0].customerId);
                setCustomerData(result.data.results);
            } else {
                setErrorMessage(result);
            }
        });
    }

    const getReportData = () => {
        const requestOptions = {
            headers: { 
                'Token': localStorage.getItem('accessToken'),
                'Content-Type': 'application/json'
            },
        };
        let url = customerId === '-1' ?
                `${CONSTANTS.API_URL}Reports/CustomerwiseApiSalesSummary?startDate=${fromDate}&endDate=${toDate}` :
                `${CONSTANTS.API_URL}Reports/CustomerwiseApiSalesSummary?startDate=${fromDate}&endDate=${toDate}&customerId=${customerId}`;
        fetch(url, requestOptions)
        .then(handleResponse)
        .then(
            (result) => {
                if(result.data) {
                    setIsLoading(false);
                    const keysToParse = ['sales', 'commission', 'total'];
                    parseFloat2Decimal(result.data.results, keysToParse);
                    setGridData(result.data.results);
                    setPageCount(Math.ceil(result.data.results.length/10));
                    let total = result.data.header;
                    const headerKeysToParse = ['salesAmount', 'commission', 'totalAmount'];
                    parseFloat2DecimalHeader(total, headerKeysToParse);
                    setTotalData([
                        total.salesAmount,
                        total.commission,
                        total.totalAmount
                    ]);
                    setExportTotalData({
                        customerName: '',
                        sales: total.salesAmount,
                        commission: total.commission,
                        total: total.totalAmount
                    });
                    setEnableExport(result.data.results.length > 0 ? true : false);
                } else {
                    setIsLoading(false);
                    setErrorMessage(result.error.message);
                }
            },
            (error) => {
                setIsLoading(false);
                setErrorMessage(error);
            }
        );
    }

    const showClickHandler = () => {
        setIsLoading(true);
        getReportData();
    }

    const rowClickHandler = rowData => {
        let detailedPage = window.open('/pavathi/customer-api-sales-detailed');
        detailedPage.startDate = fromDate;
        detailedPage.endDate = toDate;
        detailedPage.customerId = rowData.customerId;
        detailedPage.customerName = rowData.customerName;
    }

    const fromDateChangeHandler = event => setFromDate(event.target.value)
    
    const toDateChangeHandler = event => setToDate(event.target.value)

    const customerChangeHandler = event => setCustomerId(event.target.value)

    const getExportFileName = () => {
        let exportFilename = 'CustomerWiseAPISales';
        exportFilename += '_' + fromDate;
        exportFilename += '_' + toDate;
        exportFilename += customerId !== '-1' ? '_' + customerData.find(data => data.customerId == customerId)['customerName'] : '';
        setExportFileName(exportFilename);
    }
    
    return (
        <>
            { isLoading && <Loader />}
            { !isLoading && (
                <PageLayout pageTitle='Customer Wise API Sales'>
                    <div className='row mb-1'>
                        <div className='col-12' style={{display: 'flex', justifyContent:'space-between', marginTop: '6px', marginBottom: '6px'}}>
                            <form className='form-inline'>
                                <div className={`form-group ${classes.inputContainer}`}>
                                    <label className='col-form-label inputLabel'>From Date : </label>
                                    <input type='date' onKeyDown={(e) => e.preventDefault()} required className='form-control inputField' value={fromDate} onChange={fromDateChangeHandler} />
                                </div>
                                <div className={`form-group ${classes.inputContainer}`}>
                                    <label className='col-form-label inputLabel'>To Date : </label>
                                    <input type='date' onKeyDown={(e) => e.preventDefault()} required className='form-control inputField' value={toDate} onChange={toDateChangeHandler} />
                                </div>
                                <div className={`form-group ${classes.inputContainer}`}>
                                    <label className='col-form-label inputLabel'>Customer : </label>
                                    <select className='form-select customSelect' value={customerId} aria-label=".form-select-sm example" onChange={customerChangeHandler}>
                                        { customerData.map( (value, index) => {
                                            return <option key={`customer-${index}`} className='dropdownItem' value={value.customerId}>{value.customerName}</option>
                                        }) }
                                    </select>
                                </div>
                            </form>
                            <div>
                                <Button btnClass='btn btn-primary mr-8' onClick={showClickHandler} btnText='Show' />
                                <ExportToCSV 
                                    headers={csvHeaders}
                                    exportTotalData={exportTotalData}
                                    gridData={gridData}
                                    exportFileName={exportFileName} 
                                    exportClickHandler={getExportFileName} 
                                    enableExport={enableExport}
                                />
                            </div>
                        </div>
                    </div>
                    { errorMessage && <Alert alertClassName='danger' message={errorMessage} /> }
                    <Table 
                        tableHeaders={tableHeaders} 
                        dataFields={dataFields} 
                        tableConfig={tableConfig}
                        totalData={totalData}
                        pageCount={pageCount} 
                        sort={false}
                        actions={true} 
                        view={true}
                        paginate={true}
                        filter={false}
                        gridData={gridData}
                        onRowClick={rowClickHandler}
                    />
                </PageLayout>
            )}    
        </>
    );
  
}

export default CustomerWiseAPISalesPage;